<template>
  <div class="tabs-pane">
    <div class="tab-list">
      <div :class="['tab-item',{active:item.name === value}]"
           v-for="item in tablist"
           :key="item.name">
        <a href="javascript:;"
           @click="$emit('clickTab',item.name)">
          {{item.label}}
        </a>
      </div>

      <div class="current-line"
           :style="currentLineStyle"></div>
    </div>

    <div class="tab-panes">
      <div class="panes-list"
           :style="getCurrentPane">
        <div v-for="item in tablist"
             :key="item.name"
             class="panes-item">
          <slot :name="item.name">

          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabsPane',
  props: {
    tablist: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'clickTab'
  },
  computed: {
    // 获取当前线的位置
    currentLineStyle () {
      let _value = this.value
      let _list = this.tablist || []
      if (_list.length === 0) {
        return { left: '50%' }
      }
      let currentIndex = 0
      _list.some((item, index) => {
        if (item.name === _value) {
          currentIndex = index + 1
        }
      })

      // 等比均衡，在算出每一个的中间点
      return {
        left: (currentIndex - 0.5) / _list.length * 100 + '%'
      }
    },
    // 获取当前面板偏移
    getCurrentPane () {
      let _value = this.value
      let _list = this.tablist || []
      if (_list.length === 0) {
        return { transform: 'translateX(0)' }
      }

      let currentIndex = 0
      _list.some((item, index) => {
        if (item.name === _value) {
          currentIndex = index
        }
      })

      return {
        transform: `translateX(${-1 * currentIndex * 100}%)`
      }
    }
  }
}
</script>

<style lang="less">
.tabs-pane {
  width: 100%;

  .tab-list {
    position: relative;
    display: flex;
    height: 40px;
    .tab-item  {
      text-align: center;
      flex: 1;
      a {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.65);
      }

      &.active  {
        a {
          color: #3771e5;
          font-weight: 600;
        }
      }
    }

    .current-line  {
      position: absolute;
      bottom: 0;
      left: 0;
      background: #3771e5;
      width: 100px;
      height: 4px;
      transition: all 0.2s ease-in-out;
      transform: translateX(-50%);
    }
  }

  .tab-panes {
    width: 100%;
    overflow: hidden;
    .panes-list {
      display: flex;
      transition: all 0.2s ease-in-out;

      .panes-item {
        width: 100%;
        flex-shrink: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// tabs-pane.vue?9eef3da4